<template>
  <div id="app">
    <!-- This meta tag is added to make the site responsive on mobile-->
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <div id="particles-js">
    <star-banner/>
    </div>
    <div class="container-fluid">
    <page-header></page-header>
    <router-view/>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/shared/PageHeader';
import PageFooter from '@/components/shared/PageFooter';
import StarBanner from '@/components/shared/StarBanner';
import './assets/styles/main.scss';

export default {
  name: 'app',
  components: {
    PageHeader,
    PageFooter,
    StarBanner,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
// Import variables so we can use them in the component specific styling
@import 'assets/styles/_variables.scss';

//class to position the particles covering the start page
#particles-js{
    height: 100% !important;
    width: 100% !important;
    position: absolute;
     top: 0;
}

.container-fluid {
  padding: 0 !important;
  overflow-x:hidden;
}

.text-orange {
 color: $headline-text;
}

// --- FONTS --- //
p {
  @include font-size($p-font-sizes);
  color: $grey-text;
}

h1 {
  @include font-size($h1-font-sizes);
  color: $medium-blue;

}

h2 {
  @include font-size($h2-font-sizes);
  color: $medium-blue;

}
h3 {
  @include font-size($h3-font-sizes);
  color: $medium-blue;
}

h4 {
  @include font-size($h4-font-sizes);
  color: $medium-blue;
}

h5 {
  @include font-size($h5-font-sizes);
  color: $medium-blue;
}
</style>
